<template>
    <div v-if="isOpen" class="z-50 fixed inset-[-1rem] bg-black bg-opacity-50 flex items-center justify-center w-full h-full p-8">
      <div class="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative dark:bg-dark-box-bg dark:border dark:border-dark-border dark:text-dark-text max-h-[90vh] overflow-y-auto" ref="modal" :style="modalStyle">
        <!-- <h2 class="text-2xl font-bold mb-4 text-gray-800 dark:text-dark-text">Edytuj Hotel</h2> -->
        <div 
          class="cursor-move mb-4 pb-2 border-b dark:border-dark-border"
          @mousedown="startDrag"
          @touchstart="startDrag"
        >
          <h2 class="text-2xl font-bold text-gray-800 dark:text-dark-text">Edytuj Hotel</h2>
        </div>
        <button @click="closeModal" class="absolute top-2 right-2 text-gray-500 hover:text-gray-700 focus:outline-none dark:text-dark-text dark:hover:text-dark-border-hover">
          <span class="text-xl">&times;</span>
        </button>
        <form @submit.prevent="submitForm" class="space-y-4">
  
          <!-- Nazwa Stacji -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Nazwa hotelu:</label>
            <input
                v-model="localHotel.name"
                type="text"
                class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.name }"
                @input="validateField('name')"
            />
            <span v-if="localErrors.name" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.name }}</span>
          </div>

          <!-- Kod pocztowy -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1 dark:text-dark-text">Adres hotelu:</label>
            <input
                v-model="localHotel.address"
                type="text"
                class="w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
                :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.address }"
                @input="validateField('address')"
            />
            <span v-if="localErrors.address" class="text-red-500 text-sm mt-1 dark:text-dark-status-unavailable">{{ localErrors.address }}</span>
          </div>

          <!-- Submit -->
          <div class="flex justify-end">
            <button 
            type="submit" 
              :disabled="isFormInvalid" 
              class="w-full bg-button-bg text-button-text py-2 rounded-md hover:bg-button-hover focus:outline-none focus:ring focus:ring-indigo-500 dark:bg-dark-button-bg dark:hover:bg-dark-button-hover"
              :class="{ 'opacity-50 cursor-not-allowed': isFormInvalid }"
            >
              Zapisz zmiany
            </button>
          </div>
  
        </form>
      </div>
    </div>
  </template>
  
  <style scoped>
  /* Pasek przewijania w trybie ciemnym */
  .dark .overflow-y-auto::-webkit-scrollbar {
    width: 8px; /* Szerokość paska przewijania */
  }
  
  .dark .overflow-y-auto::-webkit-scrollbar-thumb {
    background-color: #2c7a7a; /* Teal-700 */
    border-radius: 8px; /* Zaokrąglenie suwaka */
    border: 2px solid #1a5d5d; /* Ciemniejszy odcień teal dla krawędzi suwaka */
  }
  
  .dark .overflow-y-auto::-webkit-scrollbar-track {
    background-color: #333333; /* Ciemne tło dla śledzenia paska */
    border-radius: 8px; /* Zaokrąglenie tła paska */
  }
  
  /* Pasek przewijania w trybie jasnym */
  .overflow-y-auto::-webkit-scrollbar {
    width: 8px; /* Szerokość paska przewijania */
  }
  
  .overflow-y-auto::-webkit-scrollbar-thumb {
    background-color: #d1d5db; /* Jasnoszary kolor suwaka (szary) */
    border-radius: 8px; /* Zaokrąglenie suwaka */
    border: 2px solid #9ca3af; /* Ciemniejszy szary dla krawędzi suwaka */
  }
  
  .overflow-y-auto::-webkit-scrollbar-track {
    background-color: #f3f4f6; /* Jasnoszare tło dla śledzenia paska */
    border-radius: 8px; /* Zaokrąglenie tła paska */
  }

  .cursor-move {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }

  .dragging {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }
  </style>
  
  <script>
  export default {
    props: {
      isOpen: Boolean,
      hotelToEdit: Object,
      errors: Object
    },
    data() {
      return {
        localHotel: {
          ...(this.hotelToEdit || {
            name: '',
            address: '',
          })
        },
        localErrors: {
            name: '',
            address: '',
        },
        isSubmitting: false,
        isDragging: false,
        dragOffset: { x: 0, y: 0 },
        modalPosition: { x: 0, y: 0 }
      };
    },
    watch: {
        hotelToEdit: {
        handler(newVal) {
          if (newVal) {
            this.localHotel = { ...newVal };
          }
        },
        immediate: true,
        deep: true
      }
    },
    computed: {
      hasErrors() {
        // Sprawdza, czy istnieją jakiekolwiek błędy walidacyjne
        return Object.values(this.localErrors).some(error => error !== '');
      },
      isFormComplete() {
        // Sprawdza, czy każde wymagane pole zostało wypełnione
        return this.localHotel.name !== '' && this.localHotel.address !== '';
      },
      isFormInvalid() {
        // Formularz jest niepoprawny, jeśli istnieją błędy lub brakuje wypełnionych pól
        return this.hasErrors || !this.isFormComplete;
      },
      modalStyle() {
        return {
          transform: `translate(${this.modalPosition.x}px, ${this.modalPosition.y}px)`
        };
      }
    },
    methods: {
      validateField(field) {
        // Aktualizacja kluczy do walidacji zgodnie z danymi dyspozytora
        switch (field) {
          case 'name':
            this.localErrors.name = !this.localHotel.name ? 'Nazwa hotelu jest wymagana' : '';
            break;
          case 'postcode':
            this.localErrors.address = !this.localHotel.address ? 'Adres hotelu jest wymagany' : '';
            break;
        }
      },
      closeModal() {
        this.$emit('close');
      },
      async submitForm() {
        if (this.isSubmitting) return;
  
        this.isSubmitting = true;
  
        // Walidacja wszystkich pól
        this.validateField('name');
        this.validateField('address');
  
        if (!Object.values(this.localErrors).some(error => error !== '')) {
          this.$emit('submit', this.localHotel);
        } else {
          console.log('Popraw błędy w formularzu przed wysłaniem.');
        }
  
        this.isSubmitting = false;
      },
      startDrag(event) {
        this.isDragging = true;
        
        event.currentTarget.classList.add('dragging');

        const clientX = event.clientX || event.touches[0].clientX;
        const clientY = event.clientY || event.touches[0].clientY;
        
        this.dragOffset.x = clientX - this.modalPosition.x;
        this.dragOffset.y = clientY - this.modalPosition.y;
        
        // Dodajemy event listeners
        document.addEventListener('mousemove', this.onDrag);
        document.addEventListener('touchmove', this.onDrag, { passive: false });
        document.addEventListener('mouseup', this.stopDrag);
        document.addEventListener('touchend', this.stopDrag);
      },
      onDrag(event) {
        if (!this.isDragging) return;
        
        event.preventDefault();
        
        const clientX = event.clientX || event.touches[0].clientX;
        const clientY = event.clientY || event.touches[0].clientY;
        
        this.modalPosition.x = clientX - this.dragOffset.x;
        this.modalPosition.y = clientY - this.dragOffset.y;
      },
      stopDrag() {
        this.isDragging = false;
        
        const dragElement = document.querySelector('.cursor-move');
        if (dragElement) {
          dragElement.classList.remove('dragging');
        }

        // Usuwamy event listeners
        document.removeEventListener('mousemove', this.onDrag);
        document.removeEventListener('touchmove', this.onDrag);
        document.removeEventListener('mouseup', this.stopDrag);
        document.removeEventListener('touchend', this.stopDrag);
      },
      resetPosition() {
        this.modalPosition = { x: 0, y: 0 };
      },
    }
  };
  </script>
  